export const machineMockData = [
  {
    id: "1",
    make: "태원정공",
    name: "STAND BENDING",
    code: "TW001-001",
    createdAt: "2025-06-01",
  },
  {
    id: "2",
    make: "서울프레스",
    name: "1호기 250T",
    code: "P0700001",
    createdAt: "2025-06-01",
  },
  {
    id: "3",
    make: "서울프레스",
    name: "2호기 250T",
    code: "P0700002",
    createdAt: "2025-06-04",
  },
  {
    id: "4",
    make: "화일프레스",
    name: "10호기 160T",
    code: "P0700010",
    createdAt: "2025-06-04",
  },
  {
    id: "5",
    make: "국일프레스",
    name: "16호기 160T",
    code: "PM016-160",
    createdAt: "2025-06-04",
  },
  {
    id: "6",
    make: "화일프레스",
    name: "17호기 80T",
    code: "PM017-080",
    createdAt: "2025-06-05",
  },
  {
    id: "7",
    make: "쌍용정공",
    name: "22호기 80T",
    code: "PM022-080",
    createdAt: "2025-06-06",
  },
  {
    id: "8",
    make: "화일프레스",
    name: "20호기 60T",
    code: "PM020-060",
    createdAt: "2025-06-06",
  },
  {
    id: "9",
    make: "화일프레스",
    name: "5호기 200T",
    code: "P0700005",
    createdAt: "2025-06-07",
  },
  {
    id: "10",
    make: "SIMPAC",
    name: "23호기 400T",
    code: "P0700023",
    createdAt: "2025-06-07",
  },
  {
    id: "11",
    make: "화일프레스",
    name: "3호기 160T",
    code: "PM003-160",
    createdAt: "2025-06-07",
  },
  {
    id: "12",
    make: "SIMPAC",
    name: "6호기 200T",
    code: "P0700006",
    createdAt: "2025-06-08",
  },
  {
    id: "13",
    make: "화일프레스",
    name: "13호기 80T",
    code: "PM013-080",
    createdAt: "2025-06-08",
  },
  {
    id: "14",
    make: "SIMPAC",
    name: "21호기 110T",
    code: "PM021-110",
    createdAt: "2025-06-10",
  },
  {
    id: "15",
    make: "화일프레스",
    name: "5호기 200T",
    code: "P0700005",
    createdAt: "2025-06-11",
  },
  {
    id: "16",
    make: "화일프레스",
    name: "20호기 60T",
    code: "PM020-060",
    createdAt: "2025-06-11",
  },
  {
    id: "17",
    make: "쌍용정공",
    name: "22호기 80T",
    code: "PM022-080",
    createdAt: "2025-06-13",
  },
  {
    id: "18",
    make: "화일프레스",
    name: "17호기 80T",
    code: "PM017-080",
    createdAt: "2025-06-13",
  },
  {
    id: "19",
    make: "국일프레스",
    name: "16호기 160T",
    code: "PM016-160",
    createdAt: "2025-06-14",
  },
  {
    id: "20",
    make: "화일프레스",
    name: "10호기 160T",
    code: "P0700010",
    createdAt: "2025-06-15",
  },
  {
    id: "21",
    make: "서울프레스",
    name: "2호기 250T",
    code: "P0700002",
    createdAt: "2025-06-16",
  },
];
